export const environment = {
    production: false,
    backoffice: {
        baseUrl: 'https://backoffice-test.ivsw.nl'
    },
    api: {
        baseUrl: "https://api-test.ivsw.nl"
    }
};